import debug from "debug";

export const logger = debug("noStrudel");
